// ข้อมูลบริษัทอย่างเป็นทางการ — แหล่งความจริงที่เดียวของแอพนี้
//
// ทำไมต้องมีไฟล์นี้: ก่อนหน้านี้หัวเอกสารถูกพิมพ์ซ้ำไว้ 3 ที่ (Dossier · PermitSheet · แผ่นสรุปแบรนด์)
// วันที่บริษัทย้ายที่อยู่หรือเปลี่ยนเบอร์ ต้องไปตามแก้ให้ครบทั้งสามที่ — ลืมที่ใดที่หนึ่งคือเอกสาร
// ที่ส่งออกไปข้างนอกมีที่อยู่ผิด แก้ไฟล์นี้ไฟล์เดียวแล้วถูกพร้อมกันทุกใบ
//
// ⚠ ตรงกับทะเบียนจริงและตรงกับ `pos.branches` (สำนักงานใหญ่) + SELLER const ใน SaleCore
//   ถ้าจะแก้ ต้องแก้ให้ตรงกันทุกแอพ ไม่ใช่แก้แค่ที่นี่

export const COMPANY = {
  legalTh: 'บริษัท แคมป์สตูดิโอ (ไทยแลนด์) จำกัด',
  legalEn: 'CAMP STUDIO (THAILAND) CO., LTD.',
  branchTh: 'สำนักงานใหญ่',
  branchEn: 'Head Office',
  addrTh: '412 ซอยสุขุมวิท 71 แขวงพระโขนงเหนือ เขตวัฒนา กรุงเทพมหานคร 10110',
  addrEn: '412 Sukhumvit 71, Phrakanong Nuea, Wattana, Bangkok 10110, THAILAND',
  tel: '+66 (0)2 096 2566',
  telTh: '02-096-2566',
  taxId: '0105560181829',
  email: 'info@campstudio.co.th',
};

// สามบรรทัดหัวเอกสาร A4 — ต้องเหมือนกันเป๊ะทุกใบที่พิมพ์ออกจากแอพนี้
export const DOC_HEAD = [
  COMPANY.legalEn,
  `${COMPANY.addrEn} (${COMPANY.branchEn})`,
  `Tel. ${COMPANY.tel} · Tax ID: ${COMPANY.taxId}`,
];

// หัวเอกสารภาษาไทย — เฉพาะใบที่ยื่นหน่วยงานราชการไทย (PermitSheet: สมอ. / เกษตร)
//   30 ต.ค. 69 user ชอบหน้าตาใบ PDF ที่ยื่น สมอ. (หัวไทย) และขอให้ใบในแอพเหมือนกัน
//   ประกอบจาก COMPANY ชุดเดียวกัน → ที่อยู่/เบอร์/เลขภาษีเปลี่ยนเมื่อไหร่ ถูกพร้อมกันทุกใบ
export const DOC_HEAD_TH = {
  name: COMPANY.legalTh,
  branch: COMPANY.branchTh,
  nameEn: COMPANY.legalEn,
  line: `${COMPANY.addrTh} · โทร ${COMPANY.telTh} · เลขประจำตัวผู้เสียภาษี ${COMPANY.taxId}`,
};

// ── ลายเซ็นท้ายอีเมล ────────────────────────────────────────────────────────
// ✅ user เคาะที่อยู่ฉบับทางการแล้ว 17 ต.ค. 2569 — **ชุดเดียวใช้ทั้งเอกสารและลายเซ็น**
//   '412 Sukhumvit 71, Phrakanong Nuea, Wattana, Bangkok 10110, THAILAND'
//   (เดิมมีสองแบบ: หัวเอกสารไม่มี THAILAND · ลายเซ็นสะกด Phra Khanong/Watthana + มี Rd — เลิกใช้แล้ว)
//   ลายเซ็นแค่ตัดเป็นสองบรรทัดให้พอดีกล่อง ตัวอักษรเหมือน addrEn ทุกตัว
export const SIGN_COMPANY = [
  COMPANY.legalEn,
  '412 Sukhumvit 71, Phrakanong Nuea,',
  'Wattana, Bangkok 10110, THAILAND',
];
export const SIGN_WEBSITE = 'https://www.campstudio.co.th';
export const SIGN_TEL_PREFIX = '+66(0)';
export const SIGN_TITLE_EXAMPLE = 'International Business Development';

// ประกอบลายเซ็นของคนคนหนึ่ง — ช่องไหนยังไม่กรอก ใส่ตัวอย่างในวงเล็บเหลี่ยมไว้ให้เห็นว่ายังขาด
export function buildSignature({ name, title, phone, email } = {}) {
  const or = (v, ph) => (v || '').trim() || `[${ph}]`;
  return [
    or(name, 'ชื่อ นามสกุล ภาษาอังกฤษ'),
    or(title, SIGN_TITLE_EXAMPLE),
    '',
    ...SIGN_COMPANY,
    `Tel: ${SIGN_TEL_PREFIX} ${or(phone, 'เบอร์โทรของพนักงาน')}`,
    `Email: ${or(email, 'อีเมลบริษัทของพนักงาน')}`,
    `Website: ${SIGN_WEBSITE}`,
  ].join('\n');
}
